import script from "./BannerView.vue?vue&type=script&lang=ts&setup=true"
export * from "./BannerView.vue?vue&type=script&lang=ts&setup=true"

import "./BannerView.vue?vue&type=style&index=0&id=58bc4f3b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58bc4f3b"]])

export default __exports__